export default __webpack_public_path__ + "static/study-cafe1-b29726837f58f63bf52724ffb79b7509.jpg";